import { HTMLAttributes, ReactElement } from 'react'

import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSSeparator from 'designSystem/components/PDSSeparator/PDSSeparator'
import { SIZE } from 'designSystem/foundations/constants/size'

type BaseProps = HTMLAttributes<HTMLDivElement>

type Props = {
  children?: string | ReactElement | ReactElement[] | string[]
} & BaseProps

export default function PDSCardHeader({ children, ...props }: Props) {
  return (
    <PDSBox {...props}>
      {children}
      <PDSSeparator marginY={SIZE.s12} />
    </PDSBox>
  )
}
